import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import truncate from '@/filters/truncate'
import workoutsGeneralFiltersModule from "@/store/modules/workouts-general-filters.module"
import {mssWorkoutsHyroxModule} from "@/store/modules/mss-workouts-hyrox.module"
import {WorkoutFilterType} from "@/types/workouts"
import {allWorkoutsModule} from "@/store/modules/all-workouts.module";
import workoutsStoreManager from "@/store/managers/workouts.store.manager";

@Component({
  filters: { truncate }
})
export default class HyroxFitnesstypeOverlayComponent extends Vue {

  get fitnessTypes() {
    return allWorkoutsModule.fitnessTypes
  }

  applyFitnessType(id: string) 
  {
    workoutsGeneralFiltersModule.setFilter({
      type: WorkoutFilterType.FITNESS_TYPE,
      id
    })
    workoutsStoreManager.applyFilters()
  }
}